export const languageKey = language => ({
  type: 'ChangeLanguageKey',
  value: language
})
